/**
 * Trunnion AI - Agent API Endpoints
 */

import apiClient from './client';
import type {
  AgentIdentity,
  AgentListResponse,
  CreateAgentRequest,
  UpdateAgentRequest,
} from '@/types';

const BASE = '/agents';

export const agentsApi = {
  list: async (params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    tier?: string;
    mode?: string;
    classification?: string;
  }): Promise<AgentListResponse> => {
    const { data } = await apiClient.get(BASE, { params });
    return data;
  },

  getById: async (id: string): Promise<AgentIdentity> => {
    const { data } = await apiClient.get(`${BASE}/${id}`);
    return data;
  },

  create: async (agent: CreateAgentRequest): Promise<AgentIdentity> => {
    const { data } = await apiClient.post(BASE, agent);
    return data;
  },

  update: async (id: string, agent: UpdateAgentRequest): Promise<AgentIdentity> => {
    const { data } = await apiClient.put(`${BASE}/${id}`, agent);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  activate: async (id: string): Promise<AgentIdentity> => {
    const { data } = await apiClient.post(`${BASE}/${id}/activate`);
    return data;
  },

  deactivate: async (id: string): Promise<AgentIdentity> => {
    const { data } = await apiClient.post(`${BASE}/${id}/deactivate`);
    return data;
  },
};
